import { TextFieldProps } from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import { InputProps, useInput } from "ra-core";
import * as React from "react";
import { FunctionComponent } from "react";
import { FieldTitle, useTranslate } from "react-admin";
import { Form } from "react-bootstrap";
import BaseInput from "../BaseInput";
import sanitizeRestProps from "../sanitizeRestProps";

const convertStringToNumber = (value) => {
  const float = parseFloat(value);

  return isNaN(float) ? null : float;
};

const NumberInput: FunctionComponent<NumberInputProps> = ({
  format,
  helperText,
  label,
  margin = "dense",
  onBlur,
  onFocus,
  onChange,
  options,
  parse = convertStringToNumber,
  resource,
  source,
  step,
  min,
  max,
  validate,
  variant = "filled",
  inputProps: overrideInputProps,
  InputProps,
  size = undefined,
  className,
  type,
  ...rest
}) => {
  const {
    id,
    input,
    isRequired,
    meta: { error, touched },
  } = useInput({
    format,
    onBlur,
    onChange,
    onFocus,
    parse,
    resource,
    source,
    type: "number",
    validate,
    ...rest,
  });

  const inputProps = { ...overrideInputProps, step, min, max };

  const hasError = !!(touched && error);
  const isValid = !!(touched && !error);

  const translate = useTranslate();

  return (
    <>
      {label !== "" && label !== false && (
        <Form.Label>
          <FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />
        </Form.Label>
      )}

      <BaseInput
        id={id}
        input={input}
        size={size}
        type={type}
        InputProps={InputProps}
        error={error}
        touched={touched}
        className={className}
        {...sanitizeRestProps(rest)}
      />

      {hasError && (
        <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
          {translate(error)}
        </Form.Control.Feedback>
      )}

      {!hasError && helperText && <Form.Text muted>{helperText}</Form.Text>}
    </>
  );
};

NumberInput.propTypes = {
  label: PropTypes.string,
  options: PropTypes.object,
  resource: PropTypes.string,
  /* @ts-ignore */
  source: PropTypes.string,
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

NumberInput.defaultProps = {
  options: {},
  step: "any",
  textAlign: "right",
};

export interface NumberInputProps
  extends InputProps<TextFieldProps>,
    Omit<
      TextFieldProps,
      | "label"
      | "helperText"
      | "onChange"
      | "onBlur"
      | "onFocus"
      | "defaultValue"
      | "size"
    > {
  step?: string | number;
  min?: string | number;
  max?: string | number;
}

export default NumberInput;
